module.exports = __webpack_public_path__ + "img/cosmo.fa2f9bb3.png";